module.exports = __webpack_public_path__ + "static/media/javascript.7f2092da.png";